import React from "react";
import { Select } from "antd";
import PropTypes from "prop-types";
import { FormattedMessage } from "react-intl";

const { Option } = Select;

const ApprovedStatusSelect = (props) => {
  const { onChange, value, disabled, popupContainer } = props;

  const statusData = [
    { value: 1, name: <FormattedMessage id="app.forms.yes" /> },
    { value: 2, name: <FormattedMessage id="app.forms.house" /> },
    { value: 3, name: <FormattedMessage id="app.forms.partial" /> },
    { value: 4, name: <FormattedMessage id="app.forms.no" /> },
  ];

  return (
    <Select
      onChange={onChange}
      getPopupContainer={(trigger) =>
        popupContainer ? popupContainer : undefined
      }
      style={{ width: "100%" }}
      value={value}
      disabled={disabled}
    >
      {statusData.map((option) => (
        <Option key={option.value} value={option.value}>
          {option.name}
        </Option>
      ))}
    </Select>
  );
};

ApprovedStatusSelect.propTypes = {
  onChange: PropTypes.func,
  value: PropTypes.oneOf([1, 2, 3, null]),
  disabled: PropTypes.bool,
  popupContainer: PropTypes.any,
};

export default ApprovedStatusSelect;
